import { chromeWord } from '@shared/branding';
import { fileTextIcon, Icon } from '../core/icons';
import { useBranding } from '../state';

/**
 * The `office.` lockup: a violet tile, and the word with its stop in teal.
 *
 * One word, one stop, same as its siblings: Compose's title bar says `compose.`,
 * Assist's `assist.`. This is *not* the design system's `Wordmark` component, which
 * renders the company name: it is the per-app lockup, so it stays hand-set here.
 *
 * The stop is teal on the light page as on the dark, as the Main board draws it:
 * teal is a signal colour everywhere else in the suite, and the full stop is the
 * single place it appears decoratively. Under an organisation's branding the word
 * and the tile come from the organisation when it has set them, and the stop stays
 * Mauvely's.
 */

export function Wordmark({ size = 17, showMark = true }: { size?: number; showMark?: boolean }) {
  const branding = useBranding();
  const word = chromeWord(branding, 'office');

  return (
    <span className="mv-word">
      {showMark && (
        <span className="mv-word-tile" aria-hidden="true">
          {branding?.logoUrl ? (
            // `objectFit` because a customer's logo is whatever shape they uploaded.
            <img src={branding.logoUrl} alt="" width={20} height={20} style={{ objectFit: 'contain', display: 'block' }} />
          ) : (
            <Icon icon={fileTextIcon} size={17} />
          )}
        </span>
      )}
      <span className="mv-word-text" style={{ fontSize: size }}>
        {word}
        <span style={{ color: 'var(--teal-400)' }}>.</span>
      </span>
    </span>
  );
}
